// extracted by mini-css-extract-plugin
module.exports = {"suggestionContainer":"MapSearch_suggestionContainer__39QQW","suggestion":"MapSearch_suggestion__1MUFc"};